import type { KanbanAgent } from '@entities/task'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useTasksKanbanStore } from '../model/store'

export const useTasksKanbanAgentsApi = async (): Promise<KanbanAgent[]> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.agents')

  const tasksKanbanStore = useTasksKanbanStore()

  try {
    const { data } = await $axios.get(url!)
    const agents: KanbanAgent[] = data.data.agents

    tasksKanbanStore.setAgents(agents)

    return agents
  } catch (err: unknown) {
    console.error(err)
    toast.error(getAxiosErrorMessage(err))

    return []
  }
}